import { IMarker } from 'types/markerCore/marker-core-type.js';
import { getFirstOfArr, isNotNullOrUndefined, predicateMarkerV1 } from 'utilities/isType.js';
import { FreezingLevelItem, hasFreezingLevel } from './marker-content-freezing.js';
import { hasMarineConditions, MarineConditionsItem } from './marker-content-marine.js';
import { hasSkiStatus, SkiStatusItem } from './marker-content-ski-status.js';
import { hasSnowfall, SnowfallItem } from './marker-content-snowfall.js';
import { hasTempLabel, TemperatureItem } from './marker-content-temp.js';
import { hasWind, WindItem } from './marker-content-wind.js';

export enum MarkerComponentType {
  Marine = 'marineConditions',
  SkiStatus = 'skiStatus',
  Snowfall = 'snowfall',
  FreezingLevel = 'freezingLevel',
  WindDisplay = 'windDisplay',
  TempDisplay = 'tempDisplay',
}

export type MarkerContentItem =
  | MarineConditionsItem
  | SkiStatusItem
  | SnowfallItem
  | FreezingLevelItem
  | WindItem
  | TemperatureItem;

/** Pass subject props into various components in addition to those already identified in subject if it renders something then regurn it */
export const getAdditionalMarkerContent = (marker?: IMarker): MarkerContentItem[] => {
  if (predicateMarkerV1(marker)) {
    const subjectItem = getFirstOfArr(marker.subject);
    if (subjectItem) {
      const marine = hasMarineConditions(subjectItem);
      const snowfall = hasSnowfall(subjectItem);
      const ski = hasSkiStatus(subjectItem);
      const freeze = hasFreezingLevel(subjectItem);
      const wind = hasWind(subjectItem);
      const temp = hasTempLabel(subjectItem);
      const results: MarkerContentItem[] = [marine, snowfall, ski, freeze, wind, temp].filter(isNotNullOrUndefined);
      return results;
    }
  }

  return [];
};
